import { useState, useRef } from "react";
import styles from "./Conditions.module.css";
import Reveal from "./Reveal";
import Icon from "./Icons";
import { conditions } from "../data/content";

function Row({ group, index, isOpen, onToggle, headingTag: H }) {
  const panelRef = useRef(null);

  return (
    <div className={`${styles.row} ${isOpen ? styles.rowOpen : ""}`}>
      <H className={styles.rowHeading}>
        <button
          type="button"
          className={styles.trigger}
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls={`condition-panel-${index}`}
          id={`condition-trigger-${index}`}
        >
          <span className={styles.index}>
            {String(index + 1).padStart(2, "0")}
          </span>

          <span className={styles.triggerCopy}>
            <span className={styles.title}>{group.title}</span>
            <span className={styles.summary}>{group.summary}</span>
          </span>

          <span className={styles.toggle} aria-hidden="true">
            <Icon name="plus" size={20} />
          </span>
        </button>
      </H>

      <div
        id={`condition-panel-${index}`}
        role="region"
        aria-labelledby={`condition-trigger-${index}`}
        className={styles.panel}
        style={{
          gridTemplateRows: isOpen ? "1fr" : "0fr",
        }}
      >
        <div className={styles.panelInner} ref={panelRef}>
          <ul className={styles.items}>
            {group.items.map((item) => (
              <li key={item} className={styles.item}>
                <span className={styles.bullet} aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default function Conditions({ headless = false }) {
  // first group open by default — the section is never a blank wall
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="conditions" className={`u-section ${styles.section}`}>
      <div className="u-shell">
        {!headless && (
          <Reveal className={styles.head}>
            <p className="u-eyebrow">{conditions.eyebrow}</p>
            <h2 className="u-h2">{conditions.heading}</h2>
            <p className="u-lead">{conditions.intro}</p>
          </Reveal>
        )}

        <Reveal
          className={`${styles.accordion} ${headless ? styles.accordionFlush : ""}`}
          delay={80}
        >
          {conditions.groups.map((group, i) => (
            <Row
              key={group.title}
              group={group}
              index={i}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              headingTag={headless ? "h2" : "h3"}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
}
